export const ENDPOINTS = {
  GAMIFICATION: {
    ME: "/api/gamification/me/",
    CHECK_IN: "/api/gamification/check-in/",
    CATALOG: "/api/gamification/catalog/",
    ACHIEVEMENTS: "/api/gamification/achievements/",
    LEDGER: "/api/gamification/ledger/",
    PURCHASES: "/api/gamification/purchases/",
    EQUIPPED_CURSOR: "/api/gamification/equipped-cursor/",
    SCHOOL_SETTINGS: "/api/organizations/current/gamification/settings/",
  },
  ADMIN: {
    BASE: {
      BACKGROUND_JOBS: "/api/admin/base/background-jobs/",
      STORAGE_AUDIT: {
        RUNS: "/api/admin/base/storage-audit/runs/",
        FINDINGS: "/api/admin/base/storage-audit/findings/",
      },
    },
    AUTH: {
      USERS: "/api/admin/auth/users/",
      USERS_EXPORT_CSV: "/api/admin/auth/users/export-csv/",
      USER_ACCESS_CONFIGS: "/api/admin/auth/user-access-configs/",
      FEATURE_FLAGS: "/api/admin/auth/feature-flags/",
      VIEW_AS_LAUNCH: "/api/admin/auth/view-as-launch/",
      VIEW_AS_REDEEM: "/api/admin/auth/view-as-redeem/",
    },
    CAMPAIGNS: {
      LIST: "/api/admin/campaigns/",
      SUBMISSIONS: "/api/admin/campaigns/submissions/",
      SUBMISSIONS_EXPORT_CSV: "/api/admin/campaigns/submissions/export-csv/",
    },
    MANAGED_LINKS: "/api/admin/managed-links/",
    OUTREACH: {
      CONFIGURATION: "/api/admin/outreach/configuration/",
      IMPORTS: "/api/admin/outreach/imports/",
      OVERVIEW: "/api/admin/outreach/overview/",
      PROSPECTS: "/api/admin/outreach/prospects/",
      SELECTION_PREVIEW: "/api/admin/outreach/selection-preview/",
      BATCHES: "/api/admin/outreach/batches/",
      SENDS: "/api/admin/outreach/sends/",
    },
    DOCUMENTS: {
      TEMPLATES: "/api/admin/documents/templates/",
      VARIABLES: "/api/admin/documents/variables/",
    },
    ENTITLEMENTS: {
      RULE_DEFINITIONS: "/api/admin/entitlements/rule-definitions/",
      USAGE_EVENTS: "/api/admin/entitlements/usage-events/",
    },
    CONTENT: {
      LESSON_PLANS: "/api/admin/content/lessonplans/",
      LESSON_PLAN_COLLECTIONS: "/api/admin/content/lessonplan-collections/",
      LESSONS: "/api/admin/content/lessons/",
      LESSON_USAGE_STATISTICS: "/api/admin/content/lesson-usage-statistics",
    },
    CONTENT_QUALITY: {
      REPORTS: "/api/admin/content-quality/reports/",
      LESSONS: "/api/admin/content-quality/lessons/",
      YOUTUBE_ANNOTATIONS: "/api/admin/content-quality/youtube-annotations/",
      RUNS: "/api/admin/content-quality/runs/",
      FINDINGS: "/api/admin/content-quality/findings/",
      CORRECTION_LESSONS: "/api/admin/content-quality/correction-lessons/",
      REVISIONS: "/api/admin/content-quality/revisions/",
      REVIEWERS: "/api/admin/content-quality/reviewers/",
    },
    PROFILES: {
      USER_STATISTICS: "/api/admin/profiles/user-statistics",
      TEACHER_RETENTION_STATISTICS:
        "/api/admin/profiles/teacher-retention-statistics",
      SUBSCRIPTION_STATISTICS: "/api/admin/payment/subscription-statistics",
      STUDENTS: "/api/admin/profiles/students/",
    },
    PAYMENT: {
      SUBSCRIPTION_RETENTION_STATISTICS:
        "/api/admin/payment/subscription-retention-statistics",
      SUBSCRIPTION_FREE_DAY_STATISTICS:
        "/api/admin/payment/subscription-free-day-statistics",
      SUBSCRIPTION_FREE_DAY_EVENTS:
        "/api/admin/payment/subscription-free-day-events",
      SUBSCRIPTION_PLANS: "/api/admin/payment/subscription-plans/",
      SUBSCRIPTIONS: "/api/admin/payment/subscriptions/",
      GIVE_USER_SUBSCRIPTION: "/api/admin/payment/give-user-subscription/",
      GRANT_SUBSCRIPTION: "/api/admin/payment/grant-subscription/",
      GRANT_FREE_MONTHS: "/api/admin/payment/grant-free-months/",
      PROVIDER_SUBSCRIPTION_PLANS:
        "/api/admin/payment/provider-subscription-plans/",
      ORDERS: "/api/admin/payment/orders/",
      SIMULATIONS: "/api/admin/payment/simulations/",
      SIMULATIONS_CATALOG: "/api/admin/payment/simulations/catalog/",
      TEACHER_ACCOUNT_SIMULATIONS:
        "/api/admin/payment/simulations/teacher-accounts/",
      PRODUCTS: "/api/admin/payment/products/",
      PAYMENT_PROCESSORS: "/api/admin/payment/payment-processors/",
      COUPONS: "/api/admin/payment/coupons/",
      PAGARME_PROXY: {
        CYCLES: "/api/admin/payment/pagarme-v5/cycles/",
        INVOICES: "/api/admin/payment/pagarme-v5/invoices/",
        CHARGES: "/api/admin/payment/pagarme-v5/charges/",
        SUBSCRIPTIONS: "/api/admin/payment/pagarme-v5/subscriptions/",
      },
    },
    REFERRALS: {
      ACCOUNTS: "/api/admin/referrals/accounts/",
      ATTRIBUTIONS: "/api/admin/referrals/attributions/",
      LEDGER: "/api/admin/referrals/ledger/",
      WITHDRAWAL_REQUESTS: "/api/admin/referrals/withdrawal-requests/",
      SIMULATION: "/api/admin/referrals/simulations/{userId}/",
      SIMULATION_REFERRALS:
        "/api/admin/referrals/simulations/{userId}/referrals/",
      SIMULATION_ADVANCE_MONTH:
        "/api/admin/referrals/simulations/{userId}/advance-month/",
    },
    ASSESSMENT: {
      ASSESSMENTS: "/api/admin/assessment/assessments/",
      ASSESSMENTS_GENERATE_PREVIEW:
        "/api/admin/assessment/assessments/generate-preview/",
      ASSESSMENTS_CREATE_FROM_PREVIEW:
        "/api/admin/assessment/assessments/create-from-preview/",
      BULK_GENERATION_OPTIONS: "/api/admin/assessment/bulk-generation/options/",
      BULK_GENERATION_JOBS: "/api/admin/assessment/bulk-generation/jobs/",
      SCORING_POLICIES: "/api/admin/assessment/scoring-policies/",
      FLOW_POLICIES: "/api/admin/assessment/flow-policies/",
      SECTIONS: "/api/admin/assessment/sections/",
      QUESTIONS: "/api/admin/assessment/questions/",
      ANSWER_OPTIONS: "/api/admin/assessment/answer-options/",
      ATTEMPTS: "/api/admin/assessment/attempts/",
      RESPONSES: "/api/admin/assessment/responses/",
    },
    AI: {
      CALL_RECORDS: "/api/admin/ai/call-records/",
      PROVIDERS: "/api/admin/ai/providers/",
      MODELS: "/api/admin/ai/models/",
      FEATURES: "/api/admin/ai/features/",
      PROBES: "/api/admin/ai/probes/",
    },
    VIDEO_CALLS: {
      USAGE_STATISTICS: "/api/admin/video-calls/usage-statistics/",
      TEACHERS: "/api/admin/video-calls/teachers/",
      CALLS: "/api/admin/video-calls/calls/",
      PLATFORM_STATISTICS: "/api/admin/video-calls/platform-statistics/",
    },
    WEBHOOKS: {
      WEBHOOK_EVENTS: "/api/admin/webhooks/webhook-events/",
    },
    NOTIFICATIONS: {
      DELIVERIES: "/api/admin/notifications/deliveries/",
      TEMPLATES: "/api/admin/notifications/templates/",
      WHATSAPP: {
        TEMPLATES: "/api/admin/notifications/whatsapp/templates/",
        ACTIONS: "/api/admin/notifications/whatsapp/actions/",
        OVERVIEW: "/api/admin/notifications/whatsapp/overview/",
        AUTO_REPLY: "/api/admin/notifications/whatsapp/auto-reply/",
        MARKETING_SUPPRESSIONS:
          "/api/admin/notifications/whatsapp/marketing-suppressions/",
      },
    },
    ORGANIZATIONS: {
      SCHOOLS: "/api/admin/organizations/",
      DETAIL: "/api/admin/organizations/{organizationId}/",
      MEMBERS: "/api/admin/organizations/{organizationId}/members/",
      MEMBER_DETAIL:
        "/api/admin/organizations/{organizationId}/members/{membershipId}/",
      BILLING_ACCOUNT:
        "/api/admin/organizations/{organizationId}/billing-account/",
      COMMERCIAL_CONFIG:
        "/api/admin/organizations/{organizationId}/commercial-config/",
      PREFERENCES: "/api/admin/organizations/{organizationId}/preferences/",
      DOMAIN_REQUESTS:
        "/api/admin/organizations/{organizationId}/domain-requests/",
      AUDIT_LOG: "/api/admin/organizations/{organizationId}/audit-log/",
      SUPPORT_NOTES: "/api/admin/organizations/{organizationId}/support-notes/",
      SUPPORT_NOTE_DETAIL:
        "/api/admin/organizations/{organizationId}/support-notes/{noteId}/",
      ROLLOUT_CHECKLIST:
        "/api/admin/organizations/{organizationId}/rollout-checklist/",
      TEACHER_MIGRATION_CANDIDATES:
        "/api/admin/organizations/{organizationId}/teacher-migration-candidates/",
      TEACHER_MIGRATION_PREVIEW:
        "/api/admin/organizations/{organizationId}/teacher-migration-preview/",
      TEACHER_MIGRATIONS:
        "/api/admin/organizations/{organizationId}/teacher-migrations/",
      EXPORTS: "/api/admin/organizations/{organizationId}/exports/",
    },
    IMPERSONATE: "/api/accounts/impersonate/",
  },
  AUTH: {
    LOGIN: "/api/accounts/login/",
    SOCIAL_AUTH: "/api/accounts/social/",
    STUDENT_SOCIAL_AUTH: "/api/accounts/student-social/",
    CREATE_TEACHER_ACCOUNT: "/api/accounts/sign-in/",
    CREATE_STUDENT_ACCOUNT: "/api/accounts/student-sign-in/",
    STUDENT_LOGIN: "/api/accounts/student-login/",
    SCHOOL_STUDENT_QUICK_ACCESS: "/api/accounts/school-student-quick-access/",
    RECORD_LOGIN: "/api/accounts/record-login/",
    REFRESH: "/api/accounts/refresh-token/",
    CHANGE_PASSWORD: "/api/accounts/change-password/",
    PASSWORD_RESET: "/api/accounts/password-reset/",
    PASSWORD_RESET_VALIDATE_TOKEN:
      "/api/accounts/password-reset/validate_token/",
    PASSWORD_RESET_CONFIRMATION: "/api/accounts/password-reset/confirm/",
    GENERATE_STUDENT_LOGIN_TOKEN: "/api/accounts/generate-student-login-token/",
    STUDENT_PASSWORD_RESET: "/api/accounts/reset-student-password/",
    CHANGE_PASSWORD_FIRST_TIME: "/api/accounts/change-password-first-time/",
    DELETE_ACCOUNT: "/api/accounts/delete-account/",
  },
  CONTENT_QUALITY: {
    REPORTS: "/api/content-quality/reports/",
  },
  EDITOR: {
    LESSON_PDF: "/api/editor/lesson-pdf-file/",
    LESSON_PERMISSIONS: "/api/editor/lesson-permissions/",
    LESSON_ANNOTATIONS: "/api/editor/lesson-annotations/",
    LESSON_AUDIOS: "/api/content/lessons/{lessonId}/audios/",
    TEACHING_CLASS_PERMISSIONS: "/api/editor/teaching-class-permissions/",
    TEACHING_CLASS_ANNOTATIONS: "/api/editor/teaching-class-annotations/",
    TEACHING_CLASS_ANSWERS:
      "/api/editor/teaching-class-annotations/{teachingClassId}/answers",
  },
  PROFILE: {
    ME: "/api/profile/me",
    ME_EXTRA_DATA: "/api/profile/me/extra-data/",
    ME_PREFERENCES: "/api/profile/me/preferences/",
    MY_STUDENTS: "/api/profile/my-students/",
    MY_STATISTICS: "/api/profile/my-statistics",
    MY_FAVORITES: "/api/profile/my-favorites/",
    FEEDBACKS: "/api/profile/feedbacks/",
  },
  ORGANIZATIONS: {
    MINE: "/api/organizations/mine/",
    SWITCH_CONTEXT: "/api/organizations/switch-context/",
    CURRENT_ASSIGNABLE_TEACHERS:
      "/api/organizations/current/assignable-teachers/",
    CURRENT_BILLING_ACCOUNT: "/api/organizations/current/billing-account/",
    CURRENT_COMMERCIAL_CONFIG: "/api/organizations/current/commercial-config/",
    CURRENT_COMMERCIAL_USAGE: "/api/organizations/current/commercial-usage/",
    CURRENT_REPORTS_OVERVIEW: "/api/organizations/current/reports/overview/",
    CURRENT_PREFERENCES: "/api/organizations/current/preferences/",
    CURRENT_DOMAIN_REQUESTS: "/api/organizations/current/domain-requests/",
    CURRENT_PREFERENCES_VERIFY_DOMAIN:
      "/api/organizations/current/preferences/verify-domain/",
    PUBLIC_PREFERENCES_BY_SLUG: "/api/organizations/public/{slug}/preferences/",
    DOMAIN_PREFERENCES: "/api/organizations/domain/preferences/",
    CURRENT_MEMBERS: "/api/organizations/current/members/",
    CURRENT_MEMBER_DETAIL: "/api/organizations/current/members/{memberId}/",
    CURRENT_INVITATIONS: "/api/organizations/current/invitations/",
    CURRENT_INVITATION_DETAIL:
      "/api/organizations/current/invitations/{invitationId}/",
    CURRENT_INVITATION_RESEND:
      "/api/organizations/current/invitations/{invitationId}/resend/",
    CURRENT_INVITATION_CANCEL:
      "/api/organizations/current/invitations/{invitationId}/cancel/",
    INVITATION_ACCEPT: "/api/organizations/invitations/{token}/accept/",
    CURRENT_ROLE_POLICIES: "/api/organizations/current/role-policies/",
    CURRENT_ROLE_POLICY_DETAIL:
      "/api/organizations/current/role-policies/{role}/",
  },
  CONTENT: {
    BOOKS: "/api/content/lessonplans/",
    CUSTOM_BOOKS: "/api/content/custom-lessonplans/",
    CUSTOM_LESSONS: "/api/content/custom-lessons/",
    SCHOOL_BOOKS: "/api/content/school-lessonplans/",
    SCHOOL_LESSONS: "/api/content/school-lessons/",
    LESSONS: "/api/content/lessonplans/{lessonplanId}/lessons/",
  },
  DOCUMENTS: {
    TEMPLATES: "/api/documents/templates/",
    STUDENTS: "/api/documents/students/",
    ORGANIZATION_PROFILE: "/api/documents/organization-profile/",
    VARIABLES: "/api/documents/variables/",
    GENERATED_DOCUMENTS: "/api/documents/generated-documents/",
  },
  ASSESSMENT: {
    AUDIO_SAMPLE: "/api/assessment/audio-sample/",
    APPLICATIONS: "/api/assessment/applications/",
    STUDENT_ACTIVITIES: "/api/assessment/students/{studentId}/activities/",
    ASSIGNMENTS: "/api/assessment/assignments/",
    ASSIGNMENTS_UNREAD_COUNT: "/api/assessment/assignments/unread-count/",
    ASSIGNMENTS_MARK_VIEWED: "/api/assessment/assignments/mark-viewed/",
    ASSESSMENTS: "/api/assessment/assessments/",
    QUESTIONS: "/api/assessment/questions/",
    ATTEMPTS: "/api/assessment/attempts/",
    ANSWER_OPTIONS: "/api/assessment/answer-options/",
    RESPONSES: "/api/assessment/responses/",
    GENERATION_OPTIONS: "/api/assessment/generation-options/",
    GENERATION_JOBS: "/api/assessment/generation-jobs/",
  },
  FINANCE: {
    RECEIVING: "/api/finance/receiving/",
    MY_PAYMENTS: "/api/finance/my-payments/",
    SCHOOL: "/api/finance/school/",
    OVERVIEW: "/api/finance/overview/",
    STUDENTS: "/api/finance/students/",
  },
  REFERRALS: {
    OVERVIEW: "/api/referrals/overview/",
    ATTRIBUTIONS: "/api/referrals/attributions/",
    LEDGER: "/api/referrals/ledger/",
    WITHDRAWAL_REQUESTS: "/api/referrals/withdrawal-requests/",
    PARTNERSHIP_INTEREST: "/api/referrals/partnership-interest/",
  },
  CALENDAR: {
    GOOGLE_STATUS: "/api/calendar/google/status/",
    GOOGLE_OAUTH_START: "/api/calendar/google/oauth/start/",
    GOOGLE_CALENDARS: "/api/calendar/google/calendars/",
    GOOGLE_SELECTION: "/api/calendar/google/selection/",
    GOOGLE_SYNC: "/api/calendar/google/sync/",
    GOOGLE_DISCONNECT: "/api/calendar/google/disconnect/",
    GOOGLE_EVENTS: "/api/calendar/google/events/",
    GOOGLE_SERIES: "/api/calendar/google/series/",
    GOOGLE_SERIES_DETAIL: "/api/calendar/google/series/{seriesId}/",
  },
  CLASSROOM: {
    CLASSROOMS: "/api/content/classrooms/",
    CLASSROOM_SCHEDULE_SLOTS: "/api/content/classroom-schedule-slots/",
    PUBLIC_CLASSROOMS: "/api/content/classrooms/code/",
    LESSON_COMPLEMENTARY_ACTIVITIES:
      "/api/content/lessons/{lessonId}/complementary-activities/",
    LESSON_COMPLEMENTARY_ASSESSMENT:
      "/api/content/lessons/{lessonId}/complementary-activities/assessment/{assessmentId}/",
    LESSON_COMPLEMENTARY_ASSESSMENT_USE:
      "/api/content/lessons/{lessonId}/complementary-activities/assessment/{assessmentId}/use/",
    LESSON_COMPLEMENTARY_ASSESSMENT_HOMEWORK:
      "/api/content/lessons/{lessonId}/complementary-activities/assessment/{assessmentId}/homework/",
    LESSON_COMPLEMENTARY_ASSESSMENT_PREVIEW_SIMULATIONS:
      "/api/content/lessons/{lessonId}/complementary-activities/assessment/{assessmentId}/preview-simulations/",
    LESSON_COMPLEMENTARY_ASSESSMENT_RESULTS:
      "/api/content/lessons/{lessonId}/complementary-activities/assessment/{assessmentId}/results/",
    BOOK_COMPLEMENTARY_ACTIVITIES:
      "/api/content/lessonplans/{bookId}/complementary-activities/",
    BOOK_COMPLEMENTARY_ASSESSMENT:
      "/api/content/lessonplans/{bookId}/complementary-activities/assessment/{assessmentId}/",
    BOOK_COMPLEMENTARY_ASSESSMENT_USE:
      "/api/content/lessonplans/{bookId}/complementary-activities/assessment/{assessmentId}/use/",
    BOOK_COMPLEMENTARY_ASSESSMENT_PREVIEW_SIMULATIONS:
      "/api/content/lessonplans/{bookId}/complementary-activities/assessment/{assessmentId}/preview-simulations/",
    BOOK_COMPLEMENTARY_ASSESSMENT_RESULTS:
      "/api/content/lessonplans/{bookId}/complementary-activities/assessment/{assessmentId}/results/",
    LINK_LESSON_TO_CLASSROOM:
      "/api/content/classrooms/{classroomId}/link_lessons/",
    LINK_STUDENT_TO_CLASSROOM:
      "/api/content/classrooms/{classroomId}/link-students/",
    UNLINK_STUDENT_FROM_CLASSROOM:
      "/api/content/classrooms/{classroomId}/unlink_students/",
    CLASSROOM_CONTENT: "/api/content/classroom-content/",
    TEACHING_CLASSES: "/api/content/teaching-class/",
    STUDENT_SELF_LINK: "/api/content/classrooms/{classroomId}/self-link/",
  },
  ATTENDANCE: {
    OVERVIEW: "/api/attendance/overview/",
    OVERVIEW_EXPORT: "/api/attendance/overview/export/",
    CALENDAR: "/api/attendance/calendar/",
    CALENDAR_SUMMARY: "/api/attendance/calendar/summary/",
    CATALOG: "/api/attendance/catalog/",
    CLASSROOMS: "/api/attendance/classrooms/",
    SESSIONS: "/api/attendance/sessions/",
    RECORDS: "/api/attendance/records/",
    STUDENTS: "/api/attendance/students/",
    SETTINGS: "/api/attendance/settings/",
    MAKEUPS: "/api/attendance/makeups/",
    MAKEUP_SESSIONS: "/api/attendance/makeup-sessions/",
  },
  VIDEO_CALLS: {
    CALLS: "/api/video-calls/calls/",
    CURRENT: "/api/video-calls/calls/current/",
    CONNECTION: "/api/video-calls/calls/{callId}/connection/",
    ROTATE_INVITATION: "/api/video-calls/calls/{callId}/invitation/rotate/",
    JOIN_REQUESTS: "/api/video-calls/calls/{callId}/join-requests/",
    APPROVE_JOIN_REQUEST:
      "/api/video-calls/calls/{callId}/join-requests/{joinRequestId}/approve/",
    DENY_JOIN_REQUEST:
      "/api/video-calls/calls/{callId}/join-requests/{joinRequestId}/deny/",
    REMOVE_PARTICIPANT:
      "/api/video-calls/calls/{callId}/participants/{participantId}/remove/",
    END_CALL: "/api/video-calls/calls/{callId}/end/",
    ROOMS: "/api/video-calls/calls/{callId}/rooms/",
    OPEN_ROOMS: "/api/video-calls/calls/{callId}/rooms/open/",
    CLOSE_ROOMS: "/api/video-calls/calls/{callId}/rooms/close/",
    MOVE_ROOM_PARTICIPANT: "/api/video-calls/calls/{callId}/rooms/move/",
    ROOM_ANNOUNCEMENTS: "/api/video-calls/calls/{callId}/rooms/announcements/",
    GUEST_ROOMS: "/api/video-calls/join-requests/{joinRequestId}/rooms/",
    GUEST_RETURN_TO_MAIN:
      "/api/video-calls/join-requests/{joinRequestId}/return-to-main/",
    GUEST_ROOM_HELP:
      "/api/video-calls/join-requests/{joinRequestId}/help-request/",
    PREVIEW_INVITATION: "/api/video-calls/invitations/preview/",
    JOIN_INVITATION: "/api/video-calls/invitations/join/",
    GUEST_JOIN_REQUEST: "/api/video-calls/join-requests/{joinRequestId}/",
    LINK_GUEST_ACCOUNT:
      "/api/video-calls/join-requests/{joinRequestId}/link-account/",
    GUEST_SIGNUP_ELIGIBILITY:
      "/api/video-calls/join-requests/{joinRequestId}/signup/eligibility/",
    GUEST_SIGNUP_PASSWORD:
      "/api/video-calls/join-requests/{joinRequestId}/signup/password/",
    GUEST_SIGNUP_GOOGLE:
      "/api/video-calls/join-requests/{joinRequestId}/signup/google/",
    GUEST_CONNECTION:
      "/api/video-calls/join-requests/{joinRequestId}/connection/",
  },
  PAYMENT: {
    USER_SUBSCRIPTION: "/api/payment/user-subscription-info",
    SUBSCRIPTION_PLANS: "/api/payment/subscription-plans/",
    CHANGE_SUBSCRIPTION_PLAN: "/api/payment/change-subscription-plan/",
    USER_PAYMENT_DATA: "/api/payment/user-payment-data",
    SUBSCRIPTIONS: "/api/payment/subscriptions/",
    ORDERS: "/api/payment/orders/",
    COUPON_CODES: "/api/payment/coupon-codes",
    CANCEL_SUBSCRIPTION_FEEDBACK: "/api/payment/cancel-subscription-feedback",
    CANCEL_SUBSCRIPTION: "/api/payment/cancel-subscription",
    CANCEL_SUBSCRIPTION_RETENTION_OFFER_ACCEPT:
      "/api/payment/cancel-subscription-retention-offer/accept",
    CLAIM_SUBSCRIPTION_FREE_DAY: "/api/payment/claim-subscription-free-day",
    UPDATE_SUBSCRIPTION_CREDIT_CARD:
      "/api/payment/update-subscription-credit-card",
  },
  BRAZIL_API: {
    CEP: "https://brasilapi.com.br/api/cep/v1/",
  },
  PAGAR_ME: {
    GENERATE_CARD_TOKEN: "https://api.pagar.me/core/v5/tokens?appId={appId}",
  },
};
